import { render, staticRenderFns } from "./AAvatar.vue?vue&type=template&id=27b19769"
import script from "./AAvatar.vue?vue&type=script&lang=ts"
export * from "./AAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports